import { Loader2 } from "lucide-react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useFirebaseAuth } from "@/hooks/useFirebaseAuth";

/**
 * Wrap delle route protette: redirect a `/login` se l'utente non è autenticato.
 * Mostra uno spinner durante il primo restore della sessione Firebase
 * (lettura da localStorage / IndexedDB).
 */
export function AuthGuard() {
  const { user, loading } = useFirebaseAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="size-5 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}
